module.exports = __webpack_public_path__ + "static/media/movr_to_ava.4795f2b0.png";